import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { getText } from '../../i18n';

const EnrollmentByAge = ({ageRanges}) => {

  const createAgeRangeLabel = ({minAge, maxAge}) => {
    return minAge + "-" + maxAge;
  }

  let bandsByAges = {}, uniquePlanTypesObject = {};

  ageRanges.forEach((ageRange) => {
    //getting band data for x axis
    if (!bandsByAges[`${ageRange.min}${ageRange.max}`]) {
      bandsByAges[`${ageRange.min}${ageRange.max}`] = {
        min: ageRange.min,
        max: ageRange.max,
        plans: {}
      };
    }

    bandsByAges[`${ageRange.min}${ageRange.max}`].plans[ageRange.name] = ageRange.count;
    uniquePlanTypesObject[ageRange.name] = true;
  })

  let bands = [];
  for (let key in bandsByAges) {
    bands.push(bandsByAges[key]);
  }

  let uniquePlanTypes = [];
  for (let key in uniquePlanTypesObject) {
    uniquePlanTypes.push(key);
  }

  bands = bands.sort((a, b) => {
    return a.min < b.min ? -1 : 1;
  });

  const options = {
    chart: {
      type: 'column',
      style: {
        fontFamily: 'Inter, sans-serif',
      },
      events: {}
    },
    credits: { 
      enabled: false 
    },
    legend: {
        align: 'center',
        enabled: true,
        symbolRadius: 20,
        itemStyle: {
          color: '#2F2B43',
          fontSize: '0.875em',
          fontWeight: '500',
        },
      },
      title: {
        text: null,
      },
      subtitle: {
        text: null,
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            style: {
              fontWeight: 'normal',
              textOutline: 'none',
              fontSize: '0.625em',
            },
          },
        },
      },
      tooltip: {
        pointFormat:
        '<span style="color:{series.color}; font-weight:600">{series.name}:</span><span style="color:#2F2B43; font-weight:600">{point.y}</span> <span style="color:#2F2B43;">({point.percentage:.0f}%)</span></br>',
        shared: true,
      },
      xAxis: {
        categories: bands.map((band) => {
          return createAgeRangeLabel({minAge: band.min, maxAge: band.max})
        }),
        tickLength: 0,
        lineColor: '#e6e6e6',
        labels:{
          style: {
            fontSize: '0.75em',
            fontWeight: '500',
            color: '#82808E',
          },
        },
      },
      yAxis: {
        min: 0,
        max: 100,
        tickInterval: 20,
        labels:{
          style: {
            fontSize: '0.75em',
            fontWeight: '600',
            color: '#82808E',
          },
        },
        title: {
          text: getText('msg_c7e9219c68cc'),
          style:{
            fontSize: '0.75em',
            fontWeight: '600',
            color: '#82808E',
          }
        },
      },
      series: uniquePlanTypes.map((planType) => {
        return {
          name: planType,
          data: bands.map((band) => {
            return band.plans[planType];
          }),
          color: `hsl(${planType.split('').map((character) => { 
            return character.charCodeAt(0); 
          }).reduce((a, b) => { 
            return a * 7 + b; 
          }) % 360},70%,85%)`
        }
      })
    // series: [
    //     {
    //       name: 'Dental',
    //       data: [25, 35, 20, 15],
    //       color: '#2B6BE4',
    //     },
    //     {
    //       name: 'Medical',
    //       data: [30, 45, 40, 15],
    //       color: '#17BDBF',
    //     },
    //     {
    //       name: 'Vision',
    //       data: [15, 20, 10, 10],
    //       color: '#F9B77B',
    //     }
    // ]
  }


  return(
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  )
};

export default EnrollmentByAge;

